import { render } from "./addBusiness.vue?vue&type=template&id=63552456"
import script from "./addBusiness.vue?vue&type=script&lang=js"
export * from "./addBusiness.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__